export function hasCommonElement(arr1: any[], arr2: any[]): boolean {
  const set = new Set(arr1);

  for (const element of arr2) {
    if (set.has(element)) {
      return true;
    }
  }

  return false;
}

export function areDistinct(arr, key) {
  let n = arr.length;
  let s = new Set();
  for (let i = 0; i < n; i++) {
    key ? s.add(arr[i][key]) : s.add(arr[i]);
  }
  return s.size == arr.length;
}

export function getCommonElements(arr1: any[], arr2: any[]) {
  const set2 = new Set(arr2);
  return arr1.filter((obj) => set2.has(obj));
}

export function getUniqueElements(arr1: any[], arr2: any[]) {
  const set2 = new Set(arr2);
  return arr1.filter((obj) => !set2.has(obj));
}

export const extractKeys = (arr, keyToFetch = "id") =>
  arr.length > 0
    ? arr.map((ele) => (typeof ele === "object" ? ele[keyToFetch] : ele))
    : [];

export const getMaxByKey = (arr, key) => {
  return arr.reduce((max, obj) => Math.max(max, obj[key]), -Infinity);
};

export const greatestValue = (arr: Array<any>, key: string) => {
  const value = arr.reduce((max, current) => {
    return current[key] > max[key] ? current : max;
  }, arr[0][key]);
  return value;
};

export const isSameIOId = (selectedLI) => {
  return selectedLI.every(
    ({ insertion_order_id }) =>
      insertion_order_id === selectedLI[0].insertion_order_id
  );
};
